import { render, staticRenderFns } from "./customizedDetail.vue?vue&type=template&id=435412cd&scoped=true"
import script from "./customizedDetail.vue?vue&type=script&lang=js"
export * from "./customizedDetail.vue?vue&type=script&lang=js"
import style0 from "./customizedDetail.vue?vue&type=style&index=0&id=435412cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435412cd",
  null
  
)

export default component.exports